module.exports = __webpack_public_path__ + "media/images/infinite_bg-83e630e6590c65c847050b92ad42ff92.png";